import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { DialogContent, Link, Dialog } from '@mui/material'

import { useCompanyBusinessSegmentTypeOptions } from '~api/models'
import FormTextField from '~shared/components/reactHookForm/input/FormTextField'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import FormAutocomplete from '~shared/components/reactHookForm/input/FormAutocomplete/FormAutocomplete'
import FormCheckbox from '~shared/components/reactHookForm/input/FormCheckbox'
import { useAutocompleteName } from '~utils/autocompleteType'

import { NewUserStep2Extended } from './useStep2'
import FormAutocompleteMultiple from "~shared/components/reactHookForm/input/FormAutocomplete/FormAutocompleteMultiple";

const Step2Form: React.FC = () => {
  const { t } = useTranslation()
  const acName = useAutocompleteName<NewUserStep2Extended>()
  const businessSegmentTypeOptions = useCompanyBusinessSegmentTypeOptions()
  const [privacyDialogOpen, setPrivacyDialogOpen] = useState(false)

  const handleDialogClosed = () => {
    setPrivacyDialogOpen(false)
  }

  return <>
    <Dialog
      open={privacyDialogOpen}
      onClose={handleDialogClosed}
      maxWidth='lg'
    >
      <DialogContent>
        Datenschutzbestimungen
      </DialogContent>
    </Dialog>

    {/** form **/}
    <Row>
      <Col>
        <FormTextField
          label={t('common:companyName')}
          name={acName('name')}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:streetAndNumber')}
          name={acName('streetAndNumber')}
        />
      </Col>
      <Col>
        <FormTextField
          label={t('common:country')}
          name={acName('country')}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:zip')}
          name={acName('zip')}
        />
      </Col>
      <Col>
        <FormTextField
          label={t('common:city')}
          name={acName('city')}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:phone')}
          name={acName('phone')}
          type='tel'
        />
      </Col>
      <Col>
        <FormAutocompleteMultiple
          disableClearable
          label={t('common:businessSegment')}
          name={acName('segments')}
          options={businessSegmentTypeOptions}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:vatId')}
          name={acName('vatId')}
        />
      </Col>
    </Row>

    <Row>
      <Col>
        <FormCheckbox
          name={acName('acceptPrivacyPolicy')}
          color='primary'
          text={
            <Trans t={t} i18nKey='form:acceptPrivacyPolicyText'>
              privacyPolicyTextFilledByI18next<Link
                // @ts-ignore ts claims event is implicit any, which is not the case. TODO: find out why
                onClick={(event) => {
                  event.preventDefault()
                  setPrivacyDialogOpen(true)
                }}
                color='secondary'
              >LinkTextFilledByI18next</Link>
            </Trans>
          }
        />
      </Col>
    </Row>
  </>
}

export default Step2Form
